import * as v from "valibot";
import {
    BaseRecordSchema,
    baseVals,
    defineRecordSchema,
    defineValidation,
    validations,
} from "../../common/validation.common";
import { DiscountUnitEnum, InvoiceScheduleEnum, TaxTypeEnum } from "../../data/enums";
import { RadiusProfileCommonSchema } from "../radius_profile/radius_profile.request";

export namespace SubscriptionValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Entries = defineValidation(
        defineRecordSchema({
            filters: v.object({
                isOnline: v.optional(v.boolean()),
                isLimited: v.optional(v.boolean()),
                sendWhatsApp: v.optional(v.boolean()),
                invoiceSchedule: v.optional(v.picklist(InvoiceScheduleEnum.values)),
                productId: v.optional(v.string()),
                associateId: v.optional(v.string()),
            }),
        }),
    );

    export const InvoiceRecord = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            label: v.optional(baseVals.string()),
            activationDate: baseVals.isoDate("Tanggal Aktivasi"),
            taxType: v.picklist(TaxTypeEnum.values),
            invoiceSchedule: v.picklist(InvoiceScheduleEnum.values),
            networkPopId: v.optional(baseVals.string()),
            networkOntId: v.optional(baseVals.string()),
            productId: baseVals.string(),
            sendWhatsApp: v.boolean(),
            agentId: v.optional(baseVals.string()),
            marketingId: v.optional(baseVals.string()),
            dedicatedData: v.optional(
                v.object({
                    price: v.number(),
                    vlanId: v.optional(baseVals.intRange(10, 4080, "VLAN ID")),
                }),
            ),
            network: v.optional(
                v.object({
                    ipGroup: baseVals.string(),
                    ipAddress: baseVals.ipv4(),
                }),
            ),
            radiusAccount: v.optional(
                v.object({
                    username: baseVals.string(),
                    password: baseVals.string(),
                }),
            ),
            radiusProfile: v.object({
                isActive: v.boolean(),
                ...RadiusProfileCommonSchema.create.entries,
            }),
            discount: v.optional(
                v.object({
                    unit: v.picklist(DiscountUnitEnum.values),
                    cost: v.pipe(baseVals.intMin(0, "Nilai Diskon")),
                }),
            ),
        }),
    );

    export const Update = defineValidation(
        v.object({
            label: v.exactOptional(baseVals.string()),
            activationDate: v.exactOptional(baseVals.isoDate("Tanggal Aktivasi")),
            taxType: v.exactOptional(v.picklist(TaxTypeEnum.values)),
            invoiceSchedule: v.exactOptional(v.picklist(InvoiceScheduleEnum.values)),
            networkPopId: v.exactOptional(baseVals.string()),
            networkOntId: v.exactOptional(baseVals.string()),
            isLimited: v.exactOptional(v.boolean()),
            sendWhatsApp: v.exactOptional(v.boolean()),
            agentId: v.exactOptional(baseVals.string()),
            productId: v.exactOptional(baseVals.string()),
            network: v.exactOptional(
                v.object({
                    isActive: v.boolean(),
                    ipGroup: v.optional(baseVals.string()),
                    ipAddress: v.optional(baseVals.ipv4()),
                }),
            ),
            radiusAccount: v.exactOptional(
                v.object({
                    isActive: v.boolean(),
                    username: v.optional(baseVals.string()),
                    password: v.optional(baseVals.string()),
                }),
            ),
            radiusProfile: v.exactOptional(
                v.object({
                    isActive: v.boolean(),
                    ...RadiusProfileCommonSchema.create.entries,
                }),
            ),
            discount: v.exactOptional(
                v.object({
                    isActive: v.boolean(),
                    unit: v.optional(v.picklist(DiscountUnitEnum.values)),
                    cost: v.optional(baseVals.intMin(0, "Nilai Diskon")),
                }),
            ),
        }),
    );

    export const UpdateAdmin = defineValidation(
        v.object({
            marketingId: v.exactOptional(baseVals.string()),
        }),
    );

    export const Remove = defineValidation(
        v.object({
            label: validations.deletable,
            networkPopId: validations.deletable,
            networkOntId: validations.deletable,
            agentId: validations.deletable,
            radiusAccount: validations.deletable,
            radiusProfile: validations.deletable,
        }),
    );

    export const RemoveAdmin = defineValidation(
        v.object({
            marketingId: validations.deletable,
        }),
    );

    export namespace API {
        export const CustomerONTInfo = defineValidation(
            v.object({
                radiusUsername: baseVals.string(),
            }),
        );
    }
}
